import { useEffect, useState } from "react";

export const useIsKids = () => {
  const [isKids, setIsKids] = useState(false);

  const profileAge = localStorage.getItem("splay:profileAge");

  useEffect(() => {
    if (profileAge) {
      setIsKids(+profileAge <= 12);
    }
  }, [profileAge]);

  return isKids;
};
